import React, { useEffect, useState } from 'react';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Button from '../../components/buttons/Button';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import { Link } from 'react-router-dom';
import { BiChevronDown, BiChevronUp, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { formatDateTime } from '../../utils/FormatDateTime';
import ConfirmModal from '../../components/popups/confirmationModal/ConfirmModal';
import { AiFillDelete } from 'react-icons/ai';
import { Edit } from '@mui/icons-material';
import { deleteBanner, getBanners } from '../../services/banner';

function Banners() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [typeFilterStatus, setTypeFilterStatus] = useState("");
    const [searchText, setSearchText] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [expandedItem, setExpandedItem] = useState(null);  // Add state for accordion

    const pageSize = 10;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getBanners(query || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handleTypeFilterChange = (value) => {
        setTypeFilterStatus(value);
        if (value !== typeFilterStatus) {
            fetchData(`?type=${value}&search=${searchText}`);
        }
    };

    const handleSearch = (value) => {
        setSearchText(value);
        fetchData(`?search=${value}&type=${typeFilterStatus}`);
    };

    const resetFilters = () => {
        setTypeFilterStatus("");
        fetchData("");
    };

    const [openingItem, setOpeningItem] = useState(null);
    const [modalIsDeleteOpen, setIsDeleteOpen] = useState(false);

    const openDeleteModal = (item) => {
        setOpeningItem(item);
        setIsDeleteOpen(true);
    };

    // Close modal
    const closeDeleteModal = () => {
        setIsDeleteOpen(false);
        setOpeningItem(null);
    };

    const deletePost = (isConfirmDelete) => {
        if (isConfirmDelete) {
            deleteCommunity(openingItem.id);
            closeDeleteModal();
        }
    };

    const deleteCommunity = async (forumId) => {
        try {
            let res = await deleteBanner(forumId);
            if (res.status === 204) {
                fetchData("");
                closeDeleteModal();
                toast.success("Banner deleted successfully");
            } else {
                toast.error("Unable to delete Forum");
            }
        } catch (error) {
            console.error("Error deleting Forum:", error);
        }
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Marketing' },
            { name: 'Banners' },
        ]} />
        <div className="flex flex-row justify-between item-center">
            <div className="py-4 flex flex-row items-center gap-4">
                <StyledHeadingText text={"Banners"} />
                {/* <SearchBar placeholder="Search Title..." onSearch={handleSearch} value={searchText} /> */}
                {/* <div className="min-w-40">
                    <Dropdown
                        name="status"
                        options={[
                            { label: "All", value: "" },
                            { label: "Mobile", value: "Mobile" },
                            { label: "Advertisement", value: "Advertisement" },
                            { label: "Dukaan", value: "Dukaan" },
                        ]}
                        value={typeFilterStatus}
                        placeholder={"Select Type"}
                        onChange={handleTypeFilterChange}
                    />
                </div> */}
                {/* {
                    typeFilterStatus.length !== 0 || searchText !== "" ?
                        <BiRefresh size={24} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                } */}
            </div>
            <Link to="/marketing/banners/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add Banner
                </Button>
            </Link>
        </div>
        <>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading size={100} />
                    </div>
                    :
                    <div className="mt-2 flex flex-row w-full gap-2">
                        <div className="max-w-full w-full">
                            {data?.length > 0 ? (
                                data.map((item, index) => (
                                    <div className="mb-4" key={index}>
                                        <div className="px-6 py-2 font-bold rounded-md bg-primary/30 flex flex-row justify-between w-full cursor-pointer" onClick={() => setExpandedItem(expandedItem === index ? null : index)}>
                                            <p className=' text-black'>{item.type}</p>
                                            {
                                                expandedItem === index ?
                                                    <BiChevronUp size={24} /> :
                                                    <BiChevronDown size={24} />
                                            }
                                        </div>
                                        {
                                            expandedItem === index &&
                                            (<div className="mt-3 mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                                                {item.data.map((item, index) => (
                                                    <div className="flex flex-col bg-white rounded-md border shadow-lg mb-4">
                                                        <div className='flex-1 group h-full w-full aspect-video rounded-md border border-black relative'>
                                                            <img src={item.image ?? ""} alt={item.image ?? `Image ${index + 1}`} className='rounded-md object-contain bg-black w-full h-full hover:scale-105' />
                                                            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-b from-transparent to-black/60 rounded-md text-white p-2">
                                                                {formatDateTime(item.created_at)}
                                                            </div>
                                                            <div className="absolute top-0 h-full left-0 right-0 rounded-md">
                                                                <div className="flex opacity-0 group-hover:opacity-100 bg-gradient-to-b from-black to-transparent p-2 flex-row justify-end w-full gap-4 transition-opacity duration-200">
                                                                    <Link to="/marketing/banners/edit" state={item}>
                                                                        <Edit className='text-primary cursor-pointer' size={16} />
                                                                    </Link>
                                                                    <BiTrash className='text-red-700 cursor-pointer' size={20} onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        openDeleteModal(item);
                                                                    }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="pt-2 border-t">
                                                            <div className="flex flex-row px-2 pb-2">
                                                                <p className='font-bold text-black flex-1'>{item.title}</p>
                                                                <p className='font-bold text-black'>{item.banner_type}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>)}
                                    </div>
                                ))
                            ) : (
                                <p>No results found.</p>
                            )}
                            {/* {
                                data.count !== 0 ?
                                        <Pagination
                                            currentPage={currentPage}
                                            
                                            pageSize={pageSize}
                                            totalEntries={data?.count}
                                            onPageChange={handlePageChange}
                                            data={data}
                                            setData={setData}
                                        />: <></>
                            } */}
                        </div>
                    </div>
            }
        </>
        <ConfirmModal
            isOpen={modalIsDeleteOpen}
            onRequestClose={closeDeleteModal}
            contentLabel=""
            onClose={closeDeleteModal}
            setIsConfirmDelete={deletePost}
            title="Are you sure to Delete?"
            icon={<AiFillDelete color="red" size={50} />}
        />
    </>);
}

export default Banners;